import {AFrameScene} from '../lib/aframe-components'
import {FloatingBackButton} from '../lib/material-ui-components'
import {createSceneHtml, createSceneHtmlAsync, getModelInfo} from './model-config'
import {getExperienceConfig, experienceExists, extractExperienceIdFromPath} from '../lib/experience-routes'
import './main.css'

declare let React: any
declare let ReactRouterDOM: any
declare let window: any
declare let XR8: any
declare let AFRAME: any

const {withRouter} = ReactRouterDOM

// Interfaccia per i parametri di animazione
interface AnimationParams {
  animation?: string
  repeat?: string
  listAnim?: string
  text?: string
}

// Componente per visualizzare esperienze dedicate tramite URL
const ExperienceViewer = withRouter(({match, location, history}: any) => {
  const [sceneHtml, setSceneHtml] = React.useState('')
  const [isLoading, setIsLoading] = React.useState(true)
  const [error, setError] = React.useState(null)
  
  // Estrai experienceId usando la funzione helper
  const experienceId = extractExperienceIdFromPath(location.pathname)
  
  // Estrai parametri dall'URL query string
  const urlParams = new URLSearchParams(location.search)
  const customParams: Record<string, string> = {}
  urlParams.forEach((value, key) => {
    customParams[key] = value
  })
  
  // Verifica se l'esperienza esiste
  if (!experienceId || !experienceExists(experienceId)) {
    return (
      <div style={{padding: '20px', textAlign: 'center'}}>
        <h2>Esperienza non trovata</h2>
        <p>L'esperienza "{experienceId || 'ID mancante'}" non è disponibile.</p>
        <button onClick={() => history.push('/')}>Torna alla home</button>
      </div>
    )
  }
  
  // Effetto per caricare la scena in modo asincrono
  React.useEffect(() => {
    const loadScene = async () => {
      try {
        setIsLoading(true)
        setError(null)
        
        // Ottieni configurazione esperienza con parametri personalizzati
        const experienceConfig = getExperienceConfig(experienceId, customParams)
        
        console.log(`🎯 Caricamento esperienza: ${experienceId}`)
        console.log(`📋 Configurazione:`, experienceConfig)
        console.log(`🔧 ModelType: ${experienceConfig.modelType}`)
        console.log(`⚙️ Parametri personalizzati:`, experienceConfig.customParams)
        
        // Estrai i parametri di animazione se presenti
        const animationParams: AnimationParams = {}
        if (experienceConfig.customParams.animation) {
          animationParams.animation = experienceConfig.customParams.animation
          animationParams.repeat = experienceConfig.customParams.repeat
          animationParams.listAnim = experienceConfig.customParams.listAnim
          animationParams.text = experienceConfig.customParams.text
        }
        
        // Crea la scena HTML dinamicamente usando la versione asincrona
        // per permettere il recupero dei parametri da WordPress
        const finalCustomParams = {
          ...experienceConfig.customParams,
          ...animationParams
        }
        
        console.log(`🎬 Generazione scena asincrona per ${experienceConfig.modelType}`)
        const asyncSceneHtml = await createSceneHtmlAsync(
          experienceConfig.modelType, 
          finalCustomParams, 
          experienceId
        )
        
        setSceneHtml(asyncSceneHtml)
        console.log(`✅ Scena HTML generata asincronamente per ${experienceConfig.modelType}`)
        
        if (animationParams.animation === 'yes') {
          console.log(`🎭 Parametri animazione:`, animationParams)
        }
        
      } catch (error) {
        console.error('❌ Errore nel caricamento dell\'esperienza:', error)
        setError(error.message || 'Errore sconosciuto')
        
        // Fallback alla versione sincrona
        try {
          const experienceConfig = getExperienceConfig(experienceId, customParams)
          const animationParams: AnimationParams = {}
          if (experienceConfig.customParams.animation) {
            animationParams.animation = experienceConfig.customParams.animation
            animationParams.repeat = experienceConfig.customParams.repeat
            animationParams.listAnim = experienceConfig.customParams.listAnim
            animationParams.text = experienceConfig.customParams.text
          }
          
          const fallbackSceneHtml = createSceneHtml(experienceConfig.modelType, {
            ...experienceConfig.customParams,
            ...animationParams
          })
          
          setSceneHtml(fallbackSceneHtml)
          console.log(`🔄 Fallback alla versione sincrona completato`)
        } catch (fallbackError) {
          console.error('❌ Errore anche nel fallback:', fallbackError)
          setError('Impossibile caricare l\'esperienza')
        }
      } finally {
        setIsLoading(false)
      }
    }
    
    loadScene()
  }, [experienceId, customParams])
  
  // Mostra loading
  if (isLoading) {
    return (
      <div style={{padding: '20px', textAlign: 'center'}}>
        <h2>Caricamento esperienza...</h2>
        <p>Sto preparando l'esperienza "{experienceId}"</p>
      </div>
    )
  }
  
  // Mostra errore
  if (error) {
    return (
      <div style={{padding: '20px', textAlign: 'center'}}>
        <h2>Errore nel caricamento</h2>
        <p>Si è verificato un errore: {error}</p>
        <button onClick={() => history.push('/')}>Torna alla home</button>
      </div>
    )
  }
  
  // Mostra la scena
  if (sceneHtml) {
    return (
      <React.Fragment>
        <FloatingBackButton />
        <AFrameScene sceneHtml={sceneHtml} />
      </React.Fragment>
    )
  }
  
  // Fallback
  return (
    <div style={{padding: '20px', textAlign: 'center'}}>
      <h2>Errore nel caricamento</h2>
      <p>Impossibile generare la scena per l'esperienza.</p>
      <button onClick={() => history.push('/')}>Torna alla home</button>
    </div>
  )
})

export {ExperienceViewer} 